import { connect, useDispatch } from 'react-redux';
import { reduxForm } from 'redux-form';
import ProcedureImpressionPlanForm from '../../../../itrust_common/components/authorised/examFormPartial/ProcedurePlanForm';
import { dndReorder } from '../../../../itrust_common/components/HelperFunctions';
import { positionsUpdate } from '../../../../itrust_common/redux/actions/positionableActions';
import { examProcedureImpressionReorder } from '../../../../redux/actions/exam/examActions';

function ExamProcedureImpressionPlanForm(props) {
  const { template, exam, submit } = props;
  const dispatch = useDispatch()

  const onDragEnd = (dnd, klass, type) => {
    let response = dndReorder(dnd, [...props[type + "_attributes"]])
    dispatch(examProcedureImpressionReorder({ [type + "_attributes"]: response["records"] }))
    dispatch(positionsUpdate({ klass: klass, data: response["positionableObj"] }))
  }

  return (
    <form>
      <ProcedureImpressionPlanForm pprops={props} submit={submit} onDragEnd={onDragEnd} exam={exam} template={template} isTemplate={false} />
    </form>
  )
}

ExamProcedureImpressionPlanForm = reduxForm({
  form: 'procedureImpressionPlanForm',
  enableReinitialize: true
})(ExamProcedureImpressionPlanForm)

const mapStateToProps = state => {
  const { exam: { exam } } = state
  return {
    examId: exam.id,
    impressions_attributes: exam.impressions_attributes,
    procedures_attributes: exam.procedures_attributes,
    initialValues: {
      id: exam.id,
      impressions_attributes: exam.impressions_attributes,
      procedures_attributes: exam.procedures_attributes
    }
  }
}

export default connect(mapStateToProps)(ExamProcedureImpressionPlanForm);